
export const EntityVeiwMapping = [
    {
        entity:'User',
        columns:[
            {headerName:"Login Id",mappedValue:"loginId"},
            {headerName:"Mobile",mappedValue:"mobile"},
            {headerName:"Name",mappedValue:"name"},
            {headerName:"Designation",mappedValue:"designation"},
            {headerName:"Status",mappedValue:"activeStatus"}
        ],
        Actions:[
            "Edit",
            "ResetPassword",
            "ChangeStatus"
        ],
        endPoint :{
            getAllData:"users",
            resetStatus:"/users"
        },
        searchEnabledColumns:[
            "loginId",
            "name",
            "mobile",
        ],
    },
    {
        entity:'ProductDetails',
        columns:[
            {headerName:"SKUCode",mappedValue:"batchCode"},
            {headerName:"SKUName",mappedValue:"skuName"},
            {headerName:"Brand",mappedValue:"brand"},
            {headerName:"Category",mappedValue:"category"},
            {headerName:"Channel",mappedValue:"channel"}
        ],
        Actions:[
            "Edit",
            "ChangeStatus"
        ],
        endPoint :{
            getAllData:"products",
            resetStatus:"/products",
            brands:"/v1/query/brand_name",
            category:"/v1/query/UniqueProductCategory"
        },
        searchEnabledColumns:[
            "skuCode",
            "skuName",
            "brand"
        ],
        additinalData:[
            "brands","category"
        ],
    },
    {
        entity:'OutletDetails',
        columns:[
            {headerName:"Outlet Code",mappedValue:"outletCode"},
            {headerName:"Secondary Outlet Code",mappedValue:"extendedAttributes.secondaryOutletCode"},
            {headerName:"Outlet Name",mappedValue:"outletName"},
            {headerName:"Salesperson ID",mappedValue:"extendedAttributes.parent-0-0-id"},
            {headerName:"Supplier ID",mappedValue:"extendedAttributes.parent-0-1-id"},
            {headerName:"Beat PJP",mappedValue:"beat"},
            {headerName:"Contact Number",mappedValue:"contactno"},
            {headerName:"Status",mappedValue:"activeStatus"}
        ],
        Actions:[
            "Edit",
            "ChangeStatus"
        ],
        endPoint :{
            getAllData:"outletDetails",
            resetStatus:"/outletDetails",
            channel:"/v1/distinctFieldData/OutletDetails/channel",
            outletType:"/v1/distinctFieldData/OutletDetails/outletType",
            outletCategory:"/v1/distinctFieldData/OutletDetails/outletCategory",
            beat:"/v1/distinctFieldData/OutletDetails/beat",
        },
        searchEnabledColumns:[
            "outletCode",
            "outletName",
        ],
        additinalData:[
            "outletCategory",
            "outletType",
            "channel",
            "beat",
        ]
    },
]

export type Entities = "User" | "ProductDetails" | "OutletDetails"